<template>
  <div>
    <v-list
      class="transparent mt-3 py-0"
      data-cy="lista_ajuda"
    >
      <ItemLista
        v-if="dadosCompra.possuiProdutoFisico"
        target="_blank"
        href="https://ajuda.monetizze.com.br/hc/pt-br/ articles/360032284631-Como-vejo-meu-c%C3%B3digo-de-rastreio-e-o-prazo-para-a-postagem-do-pedido-"
        data-cy="btn_rastreio"
      >
        Saber sobre o rastreio
      </ItemLista>
      <v-divider v-if="dadosCompra.possuiProdutoFisico" />
      <ItemLista
        v-if="dadosCompra.possuiProdutoFisico"
        target="_blank"
        href="https://ajuda.monetizze.com.br/hc/pt-br/articles/360031984492-Quais-as-garantias-para-produtos-f%C3%ADsicos-"
        data-cy="btn_garantia_fisico"
      >
        Saber sobre a garantia {{ dadosCompra.possuiProdutoDigital ? 'do produto físico' : '' }}
      </ItemLista>
      <v-divider v-if="dadosCompra.possuiProdutoFisico" />
      <ItemLista
        v-if="dadosCompra.possuiProdutoDigital"
        target="_blank"
        href="https://ajuda.monetizze.com.br/hc/pt-br/articles/360032326671-Quais-as-garantias-para-produtos-digitais-"
        data-cy="btn_garantia_digital"
      >
        Saber sobre a garantia {{ dadosCompra.possuiProdutoFisico ? 'do produto digital' : '' }}
      </ItemLista>
      <v-divider v-if="dadosCompra.possuiProdutoDigital" />
      <ItemLista
        target="_blank"
        href="https://ajuda.monetizze.com.br/hc/pt-br/sections/360006147991-Sobre-o-Produto-que-comprei"
        data-cy="btn_produto_comprei"
      >
        Saber sobre o produto que comprei
      </ItemLista>
      <v-divider />
      <ItemLista
        target="_blank"
        href="https://help.monetizze.com.br/s/topic/0TO8b0000001TlbGAE/compras-atrav%C3%A9s-da-monetizze"
        data-cy="btn_central_ajuda"
      >
        Acessar a central de ajuda
      </ItemLista>
      <v-divider />
      <v-list-item
        :disabled="btnSolicitar"
        link
        class="pa-0 mt-1"
        data-cy="btn_solicitar_reembolso"
        @click="possuiReembolso"
      >
        <v-list-item-title
          class="px-0 py-3 text-wrap"
          :class="[this.dadosCompra.reembolso ? '' : 'grey--text']"
        >
          Solicitar reembolso
        </v-list-item-title>
        <v-list-item-icon class="my-auto mb-0">
          <v-icon class="display-1">
            mdi-chevron-right
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-divider />
    </v-list>

    <SnackBar
      :mensage="snackBar.message"
      :snackbar="snackBar.show"
      :button="true"
      :color="snackBar.color"
      :timeout="snackBar.timeout"
      @changeSnackBar="value => this.snackBar.show = value.visible"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import ItemLista from '@/components/ItemLista.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'ListaAindaPrecisoDeAjuda',

  components: {
    ItemLista,
    SnackBar,
  },

  data() {
    return {
      snackBar: {
        message: 'Prazo para solicitar reembolso expirado',
        color: 'info',
        timeout: 7000,
        show: false,
      },
    };
  },


  computed: {
    ...mapGetters(['dadosCompra']),
    ...mapState(['dadosTransacao']),

    btnSolicitar() {
      return Object.keys(this.dadosCompra).length === 0;
    },

    isEcommerce() {
      return this.dadosTransacao.is_ecommerce;
    },
  },

  methods: {
    possuiReembolso() {
      if (this.dadosCompra.reembolso) {
        this.$router.push('/nao-encontrei-o-que-preciso/motivo');
      } else {
        if (this.isEcommerce) {
          this.snackBar.timeout = -1;
          this.snackBar.message = `Caro consumidor, no momento todas as solicitações de reembolso
            estão sendo realizadas <strong>diretamente com a loja responsável pelo seu pedido</strong>.
            Por favor, entre em contato com o vendedor através dos canais de comunicação informados no
            Minhas Compras ou pelo <span class="text-no-wrap">e-mail</span> recebido no momento de sua compra.`;
        }
        this.snackBar.show = true;
      }
    },
  },

};
</script>
